import type { ElementType, ReactNode } from 'react';
import React from 'react';

interface LayoutWrapperProps {
  children: JSX.Element;
  wrapper?: ElementType<{ children: ReactNode }>;
}

const LayoutWrapper = ({
  children,
  wrapper: Wrapper = React.Fragment,
}: LayoutWrapperProps) => <Wrapper>{children}</Wrapper>;

export { LayoutWrapper };
